import React from 'react';
import { notifications } from '@mantine/notifications';
import Spinner from '@hud/web-components/Spinner/Spinner';
import {
  MessageContainer,
  ActionButton,
  NotificationIcon,
} from './ToastNotification.styles';

export enum NotificationType {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  LOADING = 'LOADING',
}

const notificationIcons = {
  [NotificationType.SUCCESS]: (
    <NotificationIcon
      icon="other.successNotification"
      size="20px"
      iconColor="turquoise"
    />
  ),
  [NotificationType.ERROR]: (
    <NotificationIcon
      icon="other.errorNotification"
      size="20px"
      iconColor="red"
    />
  ),
  [NotificationType.LOADING]: <Spinner size="28px" />,
};

interface NotificationProps {
  type: NotificationType;
  message: string | React.ReactNode;
  autoClose?: number;
  actionLabel?: string;
  onAction?: () => void;
  width?: number | string;
}

export function showNotification({
  type,
  message,
  autoClose = 3000,
  actionLabel,
  onAction,
  width,
}: NotificationProps) {
  notifications.show({
    message: (
      <MessageContainer>
        <span>{message}</span>
        {onAction && (
          <ActionButton onClick={onAction}>{actionLabel}</ActionButton>
        )}
      </MessageContainer>
    ),
    autoClose,
    icon: notificationIcons[type],
    color: 'transparent',
    position: 'bottom-center',
    ...(width && { style: { width } }),
  });
}
